import { EarningsInsightRating, ManagementInsight } from '@api';
import { SmartTableColumn } from '@design/components/smart-table';
import { WithNAFallback } from '@design/components/table';
import { RatingPill } from '@terminal/widgets/earnings-insight-drawer/earnings-insight-widget/components/rating-pill/RatingPill';
import { SharedTable } from '@terminal/widgets/earnings-insight-drawer/earnings-insight-widget/components/shared-table/SharedTable';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './StrategicInsights.module.scss';

interface StrategicInsightsProps {
  managementInsights: ManagementInsight[];
}

export const StrategicInsights = ({
  managementInsights,
}: StrategicInsightsProps) => {
  const { t } = useTranslation(['earnings']);

  const tableColumns: SmartTableColumn<ManagementInsight>[] = [
    {
      key: 'title',
      label: t('earningsInsight.drawer.earningsRecap.tables.area'),
      render: (value: string) => (
        <div className={styles.styledTitleCell}>{value}</div>
      ),
    },
    {
      key: 'description',
      label: t(
        'earningsInsight.drawer.earningsRecap.tables.managementTakeaway'
      ),
      render: (value: string) => (
        <WithNAFallback
          check={value !== undefined && value !== ''}
          value={<div className={styles.styledDescriptionCell}>{value}</div>}
        />
      ),
    },
    {
      key: 'rating',
      label: t('earningsInsight.drawer.earningsRecap.tables.impactAssessment'),
      render: (value: EarningsInsightRating) => (
        <WithNAFallback
          check={!!value}
          value={
            <div className={styles.styledRatingPill}>
              <RatingPill rating={value} />
            </div>
          }
        />
      ),
    },
  ];

  return (
    <div>
      <div className={styles.title}>
        {t('earningsInsight.drawer.earningsRecap.items.managementCommentary')}
      </div>
      <SharedTable
        tableData={managementInsights.map(i => ({
          ...i,
          key: i.title,
        }))}
        tableColumns={tableColumns}
        noCellPadding
      />
    </div>
  );
};
